export default "__VITE_ASSET__CQLCnk6$__"